import logout from 'user/logout';

export default class {
    // Disconnect from authsuite then logout
    async logoutWithAuthSuite(authorizationService, onSuccess) {
        await authorizationService.disconnectDevice();
        logout(onSuccess);
    }
    logout(onSuccess) {
        logout(onSuccess);
    }
}
